import type { Environment } from '@atlassian/jira-shared-types';

export const WAC_URL: Record<Environment, string> = {
	prod: 'https://www.atlassian.com',
	dev: 'https://wac.stg.internal.atlassian.com',
	local: 'https://wac.stg.internal.atlassian.com',
	staging: 'https://wac.stg.internal.atlassian.com',
} as const;
